<template>
    <div>
        <div class="vertical" style="height:80vh; width:90vw;">
            <div class="horizontal">
                <div class="info-field horizontal">
                    <tr class="info-field-row">
<!--                        <td><p class="info-field-title">Date Range</p></td>-->
                        <td style="padding-left: 5px;" class="info-field-value">
                            <datepicker :showTime="true" :dateFrom="dateFrom" :dateTo="dateTo" :min="dateWeekAgo" :max="new Date()" @dateChanged="dateChanged"></datepicker>
                        </td>
                    </tr>
                </div>
            </div>

            <div :id="'scichart-root-' + sid" style="width: 100%; height: 100%; margin-right: 10px; align-self: center;"></div>
        </div>
    </div>
</template>

<script>
import { SciChartSurface } from "scichart/Charting/Visuals/SciChartSurface";
import { NumericAxis } from "scichart/Charting/Visuals/Axis/NumericAxis";
import { CategoryAxis } from "scichart/Charting/Visuals/Axis/CategoryAxis";
import { EAxisAlignment } from "scichart/types/AxisAlignment";
import { FastLineRenderableSeries } from "scichart/Charting/Visuals/RenderableSeries/FastLineRenderableSeries";
import { XyDataSeries } from "scichart/Charting/Model/XyDataSeries";
import { ZoomPanModifier } from "scichart/Charting/ChartModifiers/ZoomPanModifier";
import { MouseWheelZoomModifier } from "scichart/Charting/ChartModifiers/MouseWheelZoomModifier";
import { RubberBandXyZoomModifier } from "scichart/Charting/ChartModifiers/RubberBandXyZoomModifier";
import { ZoomExtentsModifier } from "scichart/Charting/ChartModifiers/ZoomExtentsModifier";
import { chartThemeMixin } from "@/utils/chartTheme";
import { NumberRange } from "scichart/Core/NumberRange";
import { RolloverModifier } from "scichart/Charting/ChartModifiers/RolloverModifier";
import { CursorModifier } from "scichart/Charting/ChartModifiers/CursorModifier";
import { EllipsePointMarker } from "scichart/Charting/Visuals/PointMarkers/EllipsePointMarker";
import { EXyDirection } from "scichart/types/XyDirection";
import { ELineDrawMode } from "scichart/Charting/Drawing/WebGlRenderContext2D"
import { EAutoRange } from "scichart/types/AutoRange";
import { LabelProvider } from "scichart/Charting/Visuals/Axis/LabelProvider/LabelProvider";
import { VerticalLineAnnotation } from "scichart/Charting/Visuals/Annotations/VerticalLineAnnotation";
import { ELabelPlacement } from "scichart/types/LabelPlacement";

import moment from 'moment'
import Datepicker from '../Datepicker.vue';

import { getDeviceStatusFromDatesToChart } from '@api'
import { BoxAnnotation } from 'scichart/Charting/Visuals/Annotations/BoxAnnotation';
export default {
    mixins: [chartThemeMixin],
    props: ['dataset', 'originaldata', 'sid', 'initialZoomOut', 'systemId', 'activeSet'],
    components: {
        Datepicker
    },
    watch: {
        dataset(newVal, oldVal){
            this.data = [...newVal]
            // this.loadNewDataset()
        },
    },
    data() {
        var dateWeekAgoTemp = new Date();
        dateWeekAgoTemp.setDate(dateWeekAgoTemp.getDate() - 7)
        dateWeekAgoTemp = new Date(dateWeekAgoTemp.getFullYear(), dateWeekAgoTemp.getMonth(), dateWeekAgoTemp.getDate())

        return {
            sciChartSurface: null,
            wasmContext: null,
            yAxis: null,
            init: false,

            dateWeekAgo: dateWeekAgoTemp,
            dateFrom: dateWeekAgoTemp,
            dateTo: new Date(),
            data: [],
            positions: {
                'Blackbox': { from: 0.75, to: 1.25 },
                'Device': { from: 1.75, to: 2.25 },
                'Rapid24h': { from: 2.75, to: 3.25 },
                'Photocells': { from: 3.75, to: 4.25 },
                'Pressure': { from: 4.75, to: 5.25 },
            },
            catalogs: [ this.$t("General"), this.$t("Blackbox"), this.$t("Device"), this.$t("Rapid24h"), this.$t("Photocells"), this.$t("Pressure")]
        }
    },
    methods: {
        async initSciChart() {
            const {sciChartSurface, wasmContext} = await SciChartSurface.create("scichart-root-" + this.sid);

            this.sciChartSurface = sciChartSurface;
            this.wasmContext = wasmContext;

            this.sciChartSurface.applyTheme(this.chartTheme())

            this.xAxis = new NumericAxis(this.wasmContext, {
                axisAlignment: EAxisAlignment.Top,
            });

            this.yAxis = new NumericAxis(this.wasmContext, { 
                axisAlignment: EAxisAlignment.Left,
                visibleRange: new NumberRange(.5, 5.5)
            });

            this.yAxis.autoTicks = false;
            this.yAxis.majorDelta = 1;
            this.yAxis.minorDelta = 0.5;
            this.yAxis.labelProvider.formatLabel = (dataValue) => parseInt(dataValue);
            this.yAxis.maxAutoTicks = 10;
            this.yAxis.minorsPerMajor = 2

            if(this.initialZoomOut == true){
                this.xAxis.growBy = new NumberRange(0.01, 0.01);
            }

            this.sciChartSurface.xAxes.add(this.xAxis)
            this.sciChartSurface.yAxes.add(this.yAxis)

            this.xAxis.labelProvider.formatLabel = (unixTimestamp) => {
                return moment(unixTimestamp).format("YYYY-MM-DD")
            };

            this.xAxis.labelProvider.formatCursorLabel = (unixTimestamp) => {
                return moment(unixTimestamp).format("YYYY-MM-DD HH:mm:ss")
            };

            this.yAxis.labelProvider.formatLabel = (val) => {
                return this.catalogs[val]
            }

            this.yAxis.labelProvider.formatCursorLabel = (val) => {
                return this.catalogs[Math.round(val)]
            };

            this.sciChartSurface.annotations.add(
                new VerticalLineAnnotation({
                    labelPlacement: ELabelPlacement.Axis,
                    showLabel: true,
                    stroke: "Red",
                    strokeThickness: 2,
                    x1: Date.now(),
                    axisLabelFill: "Red",
                    labelValue: this.$t("Now")
                }),
            );

            await this.populateSciChart(true)

            this.xAxis.autoTicks = false,
            this.xAxis.majorDelta = 86400000;
            this.xAxis.minorDelta = 17280000;
            let lastRange = 2;

            this.xAxis.visibleRangeChanged.subscribe((args) => {
                let rangeDiff = args.visibleRange.max - args.visibleRange.min;

                if (rangeDiff/3600000 <= 6 && lastRange != 0) {
                  this.xAxis.majorDelta = 600000;
                  this.xAxis.minorDelta = 120000;
                  lastRange = 0;

                  this.xAxis.labelProvider.formatLabel = (dt) => {
                    return moment(dt).format("DD.MM, HH:mm:ss")
                  }
                } else if ( rangeDiff / 3600000 > 6 && rangeDiff / 86400000 <= 2 && lastRange != 1) {
                  this.xAxis.majorDelta = 3600000;
                  this.xAxis.minorDelta = 720000;
                  lastRange = 1;

                  this.xAxis.labelProvider.formatLabel = (dt) => {
                    return moment(dt).format("DD.MM, HH:mm:ss")
                  }
                } else if (rangeDiff / 86400000 > 2 && lastRange != 2) {
                  this.xAxis.majorDelta = 86400000;
                  this.xAxis.minorDelta = 17280000;
                  lastRange = 2;

                  this.xAxis.labelProvider.formatLabel = (dt) => {
                    return moment(dt).format("DD.MM")
                  }
                }
            });
        },
        async reloadSciChart() {
            if(this.sciChartSurface.renderableSeries != null){
                this.sciChartSurface.renderableSeries.items = [];
            }

            await this.populateSciChart(false)
        },
        async populateSciChart(init) {
            this.data.filter(x => x.title != "General").forEach((e, idx) => {
                for(let i = 0; i < e.dates.length; i ++) {
                    if (new Date(e.dates[i + 1]) < this.dateFrom){
                        continue;
                    }

                    if (i == 0 && new Date(e.dates[i + 1]) > this.dateFrom) {
                        var box = new BoxAnnotation({
                            fill: ['#dc484880', '#84CA8580'][(e.values[i + 1] + 1) % 2], 
                            stroke: ['#dc4848', '#84CA85'][(e.values[i + 1] + 1) % 2], 
                            strokeThickness: 1,
                            x1: new Date(this.dateFrom).getTime(),
                            x2: new Date(e.dates[i + 1]).getTime(),
                            y1: this.positions[e.title].from,
                            y2: this.positions[e.title].to
                        });
                        this.sciChartSurface.annotations.add(box);
                        continue;
                    } 

                    var box = new BoxAnnotation({
                        fill: ['#dc484880', '#84CA8580'][e.values[i]], 
                        stroke: ['#dc4848', '#84CA85'][e.values[i]], 
                        strokeThickness: 1,
                        x1: new Date(e.dates[i]) < new Date(this.dateFrom) ? new Date(this.dateFrom).getTime() : new Date(e.dates[i]).getTime(),
                        x2: i == e.dates.length - 1 ? new Date().getTime() : new Date(e.dates[i + 1]).getTime(),
                        y1: this.positions[e.title].from,
                        y2: this.positions[e.title].to
                    });
                    this.sciChartSurface.annotations.add(box);
                }
            })

            this.xAxis.visibleRange = new NumberRange(new Date(this.dateFrom).getTime(), new Date(this.dateTo).getTime())

            if(init) {
                if(this.zoomBySelection == true) this.sciChartSurface.chartModifiers.add(new RubberBandXyZoomModifier({ xyDirection: EXyDirection.XDirection }));
                if(this.pan != false ) this.sciChartSurface.chartModifiers.add(new ZoomPanModifier({ xyDirection: EXyDirection.XDirection }));
                if(this.zoom != false) this.sciChartSurface.chartModifiers.add(new ZoomExtentsModifier({ xyDirection: EXyDirection.XDirection }));
                if(this.mouseZoom != false) this.sciChartSurface.chartModifiers.add(new MouseWheelZoomModifier({ xyDirection: EXyDirection.XDirection }));
                // const rolloverModifier = new RolloverModifier();
                // rolloverModifier.showRolloverLine = false;
                // this.sciChartSurface.chartModifiers.add(rolloverModifier);

                this.sciChartSurface.chartModifiers.add(new CursorModifier({
                    crosshairStroke: "#0095B2",
                    crosshairStrokeThickness: 1,
                    tooltipContainerBackground: "#000",
                    tooltipTextStroke: "#0095B2",
                    showTooltip: false,
                    axisLabelFill: "#0095B2",
                    axisLabelStroke: "#fff",
                    showXLine: false
                }))
            }

            // this.sciChartSurface.zoomExtents();
        },
        async loadNewDataset(){
            let result = await getDeviceStatusFromDatesToChart(this.systemId, this.dateFrom, this.dateTo)

            result.forEach((e, i) => {
                e.values.forEach((f, j) => {
                    if(f == -1){
                        result[i].values[j] = NaN
                    }
                    result[i].dates[j] = new Date(result[i].dates[j])
                })
            })

            this.data = result;

            this.reloadSciChart()
        },
        changeDataSet() {
            this.loadNewDataset();
            return;
        },
        dateChanged(dateFrom, dateTo) {
            if(this.init == false){
                return;
            }
            this.dateFrom = dateFrom
            this.dateTo = dateTo

            // this.changeDataSet()
            this.loadNewDataset()
        }
    },
    mounted: async function() {
        // console.log('mounted')
        await this.initSciChart();
        this.loadNewDataset();
        this.init = true;
    },
    beforeDestroy: async function() {
        if(this.sciChartSurface || this.wasmContext){
            this.sciChartSurface = null
            this.wasmContext = null
        }
        this.sciChartSurface = null
        this.wasmContext = null
    },
}
</script>

<style>
.info-field-title {
    font-style: normal;
    font-weight: 600;
    font-size: 12px;
    line-height: 16px;

    padding-right: 20px;
    color: #272727;
    margin: 0;
}

.info-field-row {
    width: 100%;
    margin: 0;
    padding-bottom: 5px;
}

.info-field-value {
    font-style: normal;
    font-weight: normal;
    font-size: 12px;
    line-height: 16px;

    color: #272727;
}
</style>



// WEBPACK FOOTER //
// src/components/Charts/SciChartDeviceStatus.vue